// Webpack Imports
//mbvk main.js
import 'bootstrap';
import '../node_modules/jquery.cookie/jquery.cookie.js';


( function ( $ ) {
	'use strict';

	// Focus input if Searchform is empty
	$( '.search-form' ).on( 'submit', function ( e ) {
		var search = $( this ).find( 'input' );
		if ( search.val().length < 1 ) {
			e.preventDefault();
			search.trigger( 'focus' );
		}
    } );



}( jQuery ) );
//tooltip global
$(function () {
	$('[data-toggle="tooltip"]').tooltip()
})

//remember warning close
jQuery(function( $ ){
	//felső warning sáv cookie - intranet
    $('.warning-close-intranet').click(function( e ){
        e.preventDefault();
        $.cookie('warning-box-intranet', 'closed', { path: '/',expires: 1 });

    });

	if( $.cookie('warning-box-intranet') === 'closed' ){
        $('.warning-holder-intranet').hide();
      } else {
		$('.warning-holder-intranet').show(); 
	  }

	//felső warning sáv cookie - main
    $('.warning-close').click(function( e ){
        e.preventDefault();
        $.cookie('warning-box', 'closed', { path: '/',expires: 1 });

    });

	if( $.cookie('warning-box') === 'closed' ){
        $('.warning-holder').hide();
      } else {
		$('.warning-holder').show(); 
	  }

    
	// Carousel swipe
	$("#mbvk_slider").carousel({
        interval: 5000,
        pause: "hover",
		touch: true
    }); 

	$(window).scroll(function(){ 
        if ($(this).scrollTop() > 100) { 
            $('#scroll').fadeIn(); 
        } else { 
            $('#scroll').fadeOut(); 
        } 
    }); 
    $('#scroll').click(function(){ 
        $("html, body").animate({ scrollTop: 0 }, 600); 
        return false; 
    }); 
    
});